import React from "react";

export default function About() {
  return (
    <div className="about">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <img src="./Asserts/about.png" className="img-fluid " alt="" />
            </div>
            <p>
              This april fools the dev team have chosen a very nice minigame to
              play on the etherium chain!. All sellers wil receive one ! Kanchō
              Token has a social aspect too ! tell all your telegram chats you
              want Kanchō Token them in the cheeks ! Kanchō Token everyone !
              Kanchō Token yourself if you have to !
            </p>
            <h5>
              This april fools we are all Kanchō ! but Kancho Token safe !
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h4>** Liquidty Locked</h4>
              </div>
              <div className="col-md-4">
                <h4>** Max Tx</h4>
              </div>
              <div className="col-md-4">
                <h4>** Renounced</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
